import { render } from "./LabelElement.vue?vue&type=template&id=ef12a7e0"
import script from "./LabelElement.vue?vue&type=script&lang=js"
export * from "./LabelElement.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__